import NavbarElement from "../../components/Navbar/NavbarElement";
import Hero from "../../components/Hero/Hero";
import Categories from "../../components/Categories/Categories";
import Footer from "../../components/Footer/footer";
import {
  Fruits,
  Grains,
  Grid,
  Sidebar,
  Trending,
  Tubers,
  Vegetables,
} from "./HomepageStyle";
import Card from "../../components/Card/Card";
import { useQuery } from "react-query";
import axios from "axios";
import { Link } from "react-router-dom";

const fetchProducts = async () => {
  return axios.get(
    "https://ancient-caverns-61891.herokuapp.com/api/v1/products/"
  );
};

const fetchCategory = async (category) => {
  return axios.get(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/products/category/${category}`
  );
};

const fetchVegetables = async (key, categoryId) => {
  return axios.get(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/categories/6367eb5f1a4e8b68a2e468dd`
  );
};

const fetchFruits = async (key, categoryId) => {
  return axios.get(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/categories/6367ebdf1a4e8b68a2e468e6`
  );
};

const fetchGrains = async (key, categoryId) => {
  return axios.get(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/categories/6367eb831a4e8b68a2e468e0`
  );
};

const fetchTubers = async (key, categoryId) => {
  return axios.get(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/categories/6367ebad1a4e8b68a2e468e3`
  );
};

export default function HomePage() {
  const { data, isLoading, isError, error, status } = useQuery(
    "products",
    fetchProducts,
    {
      refetchOnMount: true,
      refetchOnWindowFocus: true,
    }
  );

  const { data: vegetables, isLoading: vegetablesLoading } = useQuery(
    "vegetables",
    () => fetchVegetables("vegetables")
  );

  const { data: fruits, isLoading: fruitsLoading } = useQuery("fruits", () =>
    fetchFruits("fruits")
  );

  const { data: grains, isLoading: grainsLoading } = useQuery("grains", () =>
    fetchGrains("grains")
  );

  const { data: tubers, isLoading: tubersLoading } = useQuery("tubers", () =>
    fetchTubers("tubers")
  );

  if (isLoading) return <h1>Loading...</h1>;
  if (error) return <h1>{error}</h1>;

  return (
    <>
      <NavbarElement />
      <Hero />
      <Grid>
        <Sidebar>
          <Categories />
        </Sidebar>

        <Trending>
          <h1>Trending</h1>
          <div>
            {data.data.data.products.map((product) => {
              return (
                <Link to={`/product/${product._id}`}>
                  <Card
                    key={product._id}
                    image={product.images[0]}
                    name={product.name}
                    price={product.price}
                  />
                </Link>
              );
            })}
          </div>
        </Trending>
        <Vegetables>
          <h1>Vegetables</h1>
          {
            <div>
              {vegetables.data.data.products.map((product) => {
                return (
                  <Link to={`/product/${product._id}`}>
                    <Card
                      key={product._id}
                      image={product.images[0]}
                      name={product.name}
                      price={product.price}
                    />
                  </Link>
                );
              })}
            </div>
          }
        </Vegetables>
        <Grains>
          <h1>Grains</h1>

          {
            <div>
              {grains.data.data.products.map((product) => {
                return (
                  <Link to={`/product/${product._id}`}>
                    <Card
                      key={product._id}
                      image={product.images[0]}
                      name={product.name}
                      price={product.price}
                    />
                  </Link>
                );
              })}
            </div>
          }
        </Grains>
        <Tubers>
          <h1>Tubers</h1>

          {
            <div>
              {tubers.data.data.products.map((product) => {
                return (
                  <Link to={`/product/${product._id}`}>
                    <Card
                      key={product._id}
                      image={product.images[0]}
                      name={product.name}
                      price={product.price}
                    />
                  </Link>
                );
              })}
            </div>
          }
        </Tubers>
        <Fruits>
          <h1>Fruits</h1>
          <div>
            {fruits.data.data.products.map((product) => {
              return (
                <Link to={`/product/${product._id}`}>
                  <Card
                    key={product._id}
                    image={product.images[0]}
                    name={product.name}
                    price={product.price}
                  />
                </Link>
              );
            })}
          </div>
        </Fruits>
      </Grid>
      <Footer />
    </>
  );
}
